import { useState, useMemo } from 'react';
import { useAppSelector } from '../../../../store/store';
import {
  UsersRequest,
  selectUsers,
  totalUsers,
  usersStatus,
} from '../../../../store/reducers/UsersSlice';
import { selectClinics } from '../../../../store/reducers/ClinicSlice';
import { formatDateTime } from '../../../../utils';
import { UsersTablet } from '../../../../models/Users/Users';
import { selectRoles } from '../../../../store/reducers/RoleSlice';

const PAGE_SIZE: number = 20;

export const useUsersState = () => {
  const users = useAppSelector(selectUsers);
  const clinics = useAppSelector(selectClinics);
  const roles = useAppSelector(selectRoles);
  const totalCount = useAppSelector(totalUsers);
  const status = useAppSelector(usersStatus);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [callRequest, setCallRequest] = useState<UsersRequest>({
    PageIndex: 0,
    PageSize: pageSize,
    SortKeySelector: 'id',
    'Filter.TextSearch': '',
    'Filter.ClinicIds': [] as string[],
    'Filter.RoleIds': [] as string[],
    'Filter.IsLockout': 'all',
    SortOrder: 'Asc',
  } as UsersRequest);

  const currentUsers: UsersTablet[] = useMemo(() => {
    if (!users) return [];

    return users.map((user) => {
      return {
        id: user.id,
        userName: user.userName,
        date: formatDateTime(user.createDateTime),
        role: user.role,
        clinics: user.role.name === 'Admin' ? [] : user.clinics || [],
        isLockout: user.isLockout,
      };
    });
  }, [users]);

  const allUsers: UsersTablet[] = useMemo(
    () => [...currentUsers],
    [currentUsers],
  );

  return {
    clinics,
    roles,
    status,
    totalCount,
    pageSize,
    setPageSize,
    callRequest,
    setCallRequest,
    total: totalCount,
    currentUsers,
    allUsers,
  };
};
